import { render, staticRenderFns } from "./villageDetail.vue?vue&type=template&id=67c26de8&scoped=true&"
import script from "./villageDetail.vue?vue&type=script&lang=js&"
export * from "./villageDetail.vue?vue&type=script&lang=js&"
import style0 from "./villageDetail.vue?vue&type=style&index=0&id=67c26de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c26de8",
  null
  
)

export default component.exports